export default {
    driver_performance_cases_view_createCasesResult: "Create Cases - Result",
    driver_performance_cases_view_dateExecuted: "Date Executed",
    driver_performance_cases_view_timeExecutedMinutes: "Time Executed",
    driver_performance_cases_view_casesCreated: "Cases Created",
    driver_performance_cases_view_casesUpdated: "Cases Updated",
    driver_performance_cases_view_casesNoCoachAssigned: "Cases With No Coach Assigned",
    driver_performance_cases_view_eventsIgnoredNoDriver: "Events Ignored (No Driver Assigned)",
    driver_performance_cases_view_eventsIgnoredIncompatibleStatus: "Events Ignored (Incompatible Event Status)",
    driver_performance_cases_view_saveSuccessfully: "Cases created successfully",
    driver_performance_cases_view_close: "Close"
};
